import { api, handleResponse } from '../config';

export interface User {
  email: string;
  name: string;
  avatar?: string | null;
  // Optional default club id for post-login routing/selection
  default_club_id?: string | null;
}

export interface GoogleAuthRequest {
  token: string;
}

export interface EmailAuthRequest {
  email: string;
  password: string;
}

export interface AuthResponse {
  user: User;
  access_token?: string;
}

export const authApi = {
  googleSignIn: async (token: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/api/auth/google', { token });
    return handleResponse(response);
  },

  emailSignIn: async (email: string, password: string): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/api/auth/email', { email, password });
    return handleResponse(response);
  },

  refreshSession: async (): Promise<AuthResponse> => {
    const response = await api.post<AuthResponse>('/api/auth/refresh');
    return handleResponse(response);
  },

  getCurrentUser: async (): Promise<AuthResponse> => {
    const response = await api.get<AuthResponse>('/api/auth/me');
    return handleResponse(response);
  },

  logout: async (): Promise<{ success: boolean }> => {
    const response = await api.post<{ success: boolean }>('/api/auth/logout');
    return handleResponse(response);
  },
};
